import { GuidUtility } from "../../../utility/common/GuidUtility";
import { AssetsConfig } from "../../../config/AssetsConfig";
import { POIResultItem } from "./POISearch";
import { GeometryUtility } from "../../../utility/common/GeometryUtility";

export class DrawGeometry {

    constructor() {

        this.id = GuidUtility.getGuid();

        this.name = null;

        this.type = null;

        //默认点图标
        this.image = AssetsConfig.getDrawMarkerIcon();

        this.coordString = null;

        this.coordinates = null;

        this.crsCode = "EPSG:4326";

        this.poi=null;

        this.remark = null;
    }


    getJsonString()
    {   
        let jsonString = JSON.stringify(this);

        return jsonString;
    }




    getLength() {
        let lineLength = 0;

        let prjCoordinates = GeometryUtility.transformPoints(this.coordinates, this.crsCode, "EPSG:3857");
        let line = new ol.geom.LineString(prjCoordinates);
        lineLength = ol.sphere.getLength(line);

        return lineLength;
    }


    getArea() {
        let pynArea = 0;

        let prjCoordinates = GeometryUtility.transformPoints(this.coordinates, this.crsCode, "EPSG:3857");

        let ringArray = new Array();
        ringArray.push(prjCoordinates);
        let pyn = new ol.geom.Polygon(ringArray);
        if (pyn) {
            pynArea = pyn.getArea();
        }

        return pynArea;
    }



    /**
     * 转为搜索点
     */
    getPOIResultItem() {
        let poiItem = new POIResultItem();

        poiItem.id = this.id;
        poiItem.name = this.name;
        poiItem.crsCode = this.crsCode;
        poiItem.remark = this.remark;

        poiItem.image = this.image;
        poiItem.address = null;
        poiItem.phone = null;

        poiItem.focusStatus = false;

        poiItem.poiType = DrawGeometryType.point;
        poiItem.sn = "0";
        poiItem.focusImage = null;
        poiItem.unfocusImage = null;

        let coordinates = this.coordString.split(',');
        if (coordinates) {
            if (coordinates[0]) {
                poiItem.x = parseFloat(coordinates[0]);
            }

            if (coordinates[1]) {
                poiItem.y = parseFloat(coordinates[1]);
            }
        }

        return poiItem;
    }


    static fromJson(jsonObject)
    {   
        let drawItem=null;
        if(!jsonObject)return drawItem;

        drawItem=new DrawGeometry();
        drawItem.coordString=jsonObject.coordString;
        drawItem.coordinates=jsonObject.coordinates;
        drawItem.crsCode=jsonObject.crsCode;
        drawItem.id=jsonObject.id;
        // drawItem.image=jsonObject.image;
        drawItem.name=jsonObject.name;
        drawItem.remark=jsonObject.remark;
        drawItem.type=jsonObject.type;
        
        if(jsonObject.poi)
        {   
            drawItem.poi=POIResultItem.fromJson(jsonObject.poi);
            if(drawItem.poi)
            {   
                if(drawItem.poi.poiType===DrawGeometryType.point)
                {
                    drawItem.image=AssetsConfig.getDrawMarkerIcon();
                }
                else
                {
                    drawItem.image=AssetsConfig.getCollectPoiMarkerIcon();
                }
            }
        }
        
        return drawItem;
    }


}

export const DrawGeometryType =
{
    point: "point",

    polyline: "polyline",

    polygon: "polygon",
}